









































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CargaPesquisaSatisfacao} from '@/model/resource/CargaPesquisaSatisfacao'
import {InputCargaPesquisaSatisfacaoSchema} from '@/schema/resource/CargaPesquisaSatisfacao/InputCargaPesquisaSatisfacaoSchema'

@Component
export default class PersistCargaPesquisaSatisfacaoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaPesquisaSatisfacaoSchema()
  cargaPesquisaSatisfacao = new CargaPesquisaSatisfacao()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.cargaPesquisaSatisfacao.getCargaPesquisaSatisfacao(id)
    }

    $.await.done('getCargaPesquisaSatisfacao')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.cargaPesquisaSatisfacao.persistCargaPesquisaSatisfacao()
    await Helper.successAndPush(
      'system.success.persist',
      '/carga-pesquisa-satisfacao/list'
    )
  }
}
